/**
 * Single source of truth for the SAS community contact channels.
 *
 * Used by:
 *  - Home hero "Join the Community" popover
 *  - Footer "Community" column
 *  - /contact page "Contact & Community" block
 *  - /support pages
 *
 * Updating a URL here updates every surface at once.
 */
export const COMMUNITY_LINKS = {
  whatsappGroup: "https://chat.whatsapp.com/CAg2p5OfSR977rk0J6hvVn?mode=gi_t",
  whatsappChannel: "https://whatsapp.com/channel/0029VbAs3BO4tRrqP9lgxw2h",
  email: "info@syrianaisociety.com",
};

export const EMAIL_HREF = `mailto:${COMMUNITY_LINKS.email}`;
